import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { commonNavigationLinks, commonTitles } from "../options/IOption";

function useNavigation(url) {
  const translation = (key) => t(`navigation.loyacStaff.${key}`);
  const { t } = useTranslation();

  const staff = useSelector((state) => state.rootAuth?.loyacStaff);

  const department = staff?.department;
  const isLSV = department === "LSV";
  const isCommunicationsDep = department === "Communications Department";
  const isProfDevDep = department === "Professional Development Department";
  const isMonitorAndEvalDep =
    department === "Monitoring & Evaluation Department";
  const isViewOnly = staff?.view_only;

  const staffDashboardLinks = [
    {
      title: "Registration Summary",
      to: "/staff/dashboard?status=&coreArea=&month=&year=2024",
      value: "staff/dashboard",
    },
    {
      title: "Program Analytics",
      to: "/staff/dashboard/analytics",
      value: "staff/dashboard/analytics",
      testing: true,
    },
  ];
  const importantLinks = [
    {
      title: "Human Resources",
      to: "https://drive.google.com/drive/folders/1aA79ELN7WMTCLdY481UVH7xxcUC0ZeXq",
      value: "newTab/human/resources",
    },
    {
      title: "Communications",
      to: "https://drive.google.com/drive/folders/1WjmNuiLysYiCyeH6LwXbrbKJo_umbnBr",
      value: "newTab/communication/department",
    },
    {
      title: "Research and Development",
      to: "https://drive.google.com/drive/folders/1eFrSnE8jjFy3zIATPXODyE_3RYJkTyAv?usp=drive_link",
      value: "newTab/rnd/department",
    },
  ];
  const loyacStaff = [
    {
      title: t("auth.dashboard"),
      to: "/staff/dashboard",
    },
    ...(!isMonitorAndEvalDep && !isViewOnly
      ? [
          {
            title: translation("newProgram"),
            to: "/create-update/program/",
          },
        ]
      : []),
    commonNavigationLinks(t).programs,
    {
      title: translation("lists"),
      isChildren: true,
      children: [
        ...(isLSV
          ? [
              {
                title: translation("locationsList"),
                to: "/locations/",
              },
              {
                title: translation("lsvUshersList"),
                to: "/ushers/",
              },
              {
                title: translation("initiativesManagementList"),
                to: "/initiatives/list/manage/",
              },
              {
                title: translation("levelsList"),
                to: "/levels/",
              },
              {
                title: translation("tagsList"),
                to: "/tags/",
              },
            ]
          : [
              {
                title: translation("registrationLists"),
                to: "/registrations/",
              },
              { title: translation("membersList"), to: "/applicants/" },
              { title: translation("supervisorsList"), to: "/supervisors/" },
              { title: t("pages.coreProgram.title"), to: "/core/programs/" },
              {
                title: t("pages.programDetails.staff.applicantCredits"),
                to: "/credits/",
              },

              { title: translation("orders"), to: "/orders/" },
            ]),
        {
          title: "Manual Hours",
          to: "/staff/manual-hours",
        },
        ...(isProfDevDep || isViewOnly
          ? [
              commonNavigationLinks(t).requestsList,
              commonNavigationLinks(t).invitationsList,
              {
                title: "Internship extensions",
                to: "/internship-extensions/",
              },
            ]
          : []),

        ...(department === "Community Service Department"
          ? [
              commonTitles(t, "/volunteer_requests").requestsList,
              {
                title: translation("communityServiceCentersList"),
                to: "/community_center/list/",
              },
              {
                title: translation("invitationsList"),
                to: "/community_center/invitations/",
              },
              {
                title: translation("reports"),
                to: "/smj_reports/",
              },
            ]
          : []),
      ],
    },
    ...(isProfDevDep
      ? [
          {
            title: translation("reports"),
            to: "/reports",
          },
        ]
      : []),
    ...(!isLSV ? [commonNavigationLinks(t).threadsList] : []),
    {
      title: t("common.events"),
      to: "/staff/events/",
    },
    ...(isCommunicationsDep
      ? [
          {
            title: translation("sendPushNotification"),
            to: "/staff/push-notifications/send/",
          },
        ]
      : []),
  ];

  const tempEvents = [
    {
      title: t("common.events"),
      to: "/staff/events/",
    },
  ];

  return { loyacStaff, tempEvents, staffDashboardLinks, importantLinks };
}

export default useNavigation;
